const funnyPlayerNames = [
  "Sir Dabbington",
  "Captain Clutch",
  "Dribble McDunkface",
  "The Snark Knight",
  "Sneaky Pete",
  "Turbo Turtle",
  "El Guapo",
  "Wiggles McJiggles",
  "Captain Obvious",
  "Major Pain",
  "Sir Laughs-a-lot",
  "Bingo Bango",
  "Professor Wigglebottom",
  "The Noobinator",
  "Mr. Chuckles",
  "Dunkin Donuts",
  "Agent Puns",
  "Captain Chaos",
  "The Meme Machine",
  "Sarge McLarge",
  "Sir Dance-a-lot",
  "The Lag Wizard",
  "Sir Fartsalot",
  "Captain Quirk",
  "Lord of the Pings",
  "The Giggler",
  "The Ninja Cat",
  "El Pollo Loco",
  "Bigfoot Believer",
  "The Baconator",
  "Sir Hops-a-lot",
  "Mr. Fluffy",
  "Captain Gigglepants",
  "Sneezy McSneezerson",
  "Turbo McSpeedster",
  "Major Tomfoolery",
  "The Waffle King",
  "Dr. Giggles",
  "Sir Barksalot",
  "Captain Capslock",
  "Mr. Gigglesworth",
  "The Muffin Man",
  "Sir Jumpsalot",
  "Professor Snickers",
  "The Chucklenator",
  "Captain Sarcasm",
  "The Fart Knight",
  "Sir Laughs-a-lot",
  "The Chucklemaster",
  "Major Giggle",
  "The Noob Slayer",
  "Captain LOL",
  "Sir Lancelol",
  "Dr. Punny",
  "The Meme Lord",
  "Captain Sillypants",
  "The Chuckle Factory",
  "Sir Lulz-a-lot",
  "The Prankster",
  "Captain Smirk",
  "Sir LOLsalot",
  "The Funnyman",
  "Captain Cackle",
  "Sir Laughster",
  "The Gigglemeister",
  "Captain Goofball",
  "Sir Chuckles",
  "The Jokester",
  "Captain Comedy",
  "Sir Smirk-a-lot",
  "The Chucklenator",
  "Major Lulz",
  "Captain Bananapants",
  "The Laughter King",
  "Sir Puns-a-lot",
  "The Joker",
  "Captain Chuckles",
  "Sir Laughstagram",
  "The Snicker King",
  "Captain Prank",
  "Sir LOLercoaster",
  "The Gag Master",
  "Captain Puns",
  "Sir Laughington",
  "The Mirth Maker",
  "Captain Jokey",
  "Sir Guffaw",
  "The Silly Sir",
  "Captain Lulz",
  "Sir Laughmore",
  "The Grinster",
  "Captain Snicker",
  "Sir Laugh-alot",
  "The Chuckle Boss",
  "Captain Hilarity",
  "Sir Mirthful",
  "The Jokemeister",
  "Captain Prankster",
  "Sir Lulzington",
  "The Giggle Lord",
  "Captain Laughs",
  "Sir Hahaha",
  "The Punisher",
  "Captain Tehehe",
];

export function deterministicPlayerName(input: string): string {
  // Simple hash function to create a deterministic index from the input string
  function hashString(str: string): number {
    let hash = 0;
    for (let i = 0; i < str.length; i++) {
      hash = (hash << 5) - hash + str.charCodeAt(i);
      hash |= 0; // Convert to 32bit integer
    }
    return Math.abs(hash);
  }

  // Get a deterministic index for the funnyPlayerNames array
  const nameIndex = hashString(input) % funnyPlayerNames.length;

  // Get a deterministic number between 10 and 99
  const number = 10 + (hashString(input) % 90);

  return `${funnyPlayerNames[nameIndex]} ${number}`;
}
